import { IResponse } from "models";

export enum ActionType {
  DELETE_BUSINESS_USER = "action/DELETE_BUSINESS_USER",
  DELETE_BUSINESS_USER_SUCCESS = "action/DELETE_BUSINESS_USER_SUCCESS",
  DELETE_BUSINESS_USER_ERROR = "action/DELETE_BUSINESS_USER_ERROR",
  DELETE_BUSINESS_USER_RESET = "action/DELETE_BUSINESS_USER_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDeleteBusinessUserPayload {
  id: number;
  status: number;
}

export interface DeleteBusinessUserResponse extends IResponse {}
